/**
 * IMPORTS
 */

import type { ReactNode } from "react";

import { ShieldX } from "lucide-react";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { type FeatureKey, hasAnyFeature } from "@/utils/auth/features";

type FeatureRouteProps = {
  /** A rota é liberada quando o usuário tem pelo menos uma destas features. */
  features: readonly FeatureKey[];
  children: ReactNode;
};

/**
 * Bloqueia a tela para quem não tem a feature, inclusive quando a URL é digitada direto.
 * A API também valida as features, então isso é só a camada visual.
 */
function FeatureRoute({ features, children }: FeatureRouteProps) {
  const userFeatures = useStoreZustandUserAuth((state) => state.features);

  if (!hasAnyFeature(userFeatures, features)) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 text-center">
        <ShieldX className="size-12 text-red-600" />
        <h2 className="text-xl font-semibold text-gray-800">Acesso negado</h2>
        <p className="max-w-md text-sm text-gray-500">
          Você não tem permissão para acessar esta tela. Fale com o administrador caso precise de
          acesso.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}

/**
 * EXPORTS
 */
export { FeatureRoute };
